import { environment } from "../environments/environment";

//Manter o número inteiro sem o ex: 5.0 (erro) || 5 (correto);
export const VersaoNum = 13;
export const VersaoProd = "13.0";
export const VersaoDebug = "13.0b";
export const TipoCompilacao = environment.production;
